module.exports = __webpack_public_path__ + "static/media/home-verify-icon.706c6880.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-verify-icon.svg
// module id = 1901
// module chunks = 0